import { useMutation } from 'react-query';

/**
 * Services
 */
import resetPassword from '@/src/services/auth/resetPassword';

export function useResetPassword() {
  return useMutation(resetPassword);
}
